import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PickupForm from "./PickupForm";
import PickupFormModal from "../common/PickupFormModal";
import cajaTransparente from "../../assets/images/CAJA_TRANSPARENTE.png";
import elPaketLogoShortIMG from "../../assets/images/logo-elpaket-short.png";
import styles from "../../styles/app/HeroPickupSection.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShieldAlt,
  faTruck,
  faBox,
  faGlobe,
  faArrowRight,
  faMapMarkerAlt,
  faClock,
  faHeadset,
} from "@fortawesome/free-solid-svg-icons";

const HeroPickupSection: React.FC = () => {
  const navigate = useNavigate();
  const [showPickupModal, setShowPickupModal] = useState(false);

  const scrollToForm = () => {
    const formElement = document.getElementById("pickup-form-container");
    if (formElement) {
      formElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className={styles["hero-pickup-section"]} id="pickup">
      <div className={styles["hero-pickup-bg-overlay"]}></div>

      <div className={styles["hero-content-wrapper"]}>
        <div className={styles["hero-grid-container"]}>
          {/* Left Column: Details, Icons, CTAs and Center Box */}
          <div className={styles["hero-left-column"]}>
            <div className={styles["hero-text-content"]}>
              <span className={styles["hero-tagline"]}>
                Envíos a Latinoamérica
              </span>

              <h1 className={styles["hero-main-title"]}>
                Desde cualquier <br />
                lugar de USA
              </h1>

              <p className={styles["hero-subtitle"]}>
                Recogemos y enviamos tus paquetes de forma segura y rápida a
                cientos de destinos en Latinoamérica.
              </p>

              {/* Horizontal icons (4 items) */}
              <div className={styles["hero-features-row"]}>
                <div className={styles["feature-item"]}>
                  <div className={styles["feature-icon-circle"]}>
                    <FontAwesomeIcon icon={faTruck} />
                  </div>
                  <span className={styles["feature-label"]}>
                    Recogida
                    <br />
                    en USA
                  </span>
                </div>
                <div className={styles["feature-item"]}>
                  <div className={styles["feature-icon-circle"]}>
                    <FontAwesomeIcon icon={faBox} />
                  </div>
                  <span className={styles["feature-label"]}>
                    Rastreo en
                    <br />
                    tiempo real
                  </span>
                </div>
                <div className={styles["feature-item"]}>
                  <div className={styles["feature-icon-circle"]}>
                    <FontAwesomeIcon icon={faShieldAlt} />
                  </div>
                  <span className={styles["feature-label"]}>
                    Paquetes
                    <br />
                    asegurados
                  </span>
                </div>
                <div className={styles["feature-item"]}>
                  <div className={styles["feature-icon-circle"]}>
                    <FontAwesomeIcon icon={faGlobe} />
                  </div>
                  <span className={styles["feature-label"]}>
                    Envíos a<br />
                    5+ países
                  </span>
                </div>
              </div>

              {/* CTA Buttons */}
              <div className={styles["hero-cta-buttons"]}>
                <button
                  className={`${styles["cta-btn"]} ${styles["cta-primary"]}`}
                  onClick={() => navigate("/calculator")}
                >
                  Cotizar envío{" "}
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className={styles["btn-arrow"]}
                  />
                </button>
                <button
                  className={`${styles["cta-btn"]} ${styles["cta-secondary"]}`}
                  onClick={() => navigate("/track")}
                >
                  Rastrear paquete{" "}
                  <FontAwesomeIcon
                    icon={faMapMarkerAlt}
                    className={styles["btn-pin"]}
                  />
                </button>
                <button
                  className={`${styles["cta-btn"]} ${styles["cta-pickup-mobile"]}`}
                  onClick={() => setShowPickupModal(true)}
                >
                  Solicitar recogida{" "}
                  <FontAwesomeIcon
                    icon={faTruck}
                    className={styles["btn-truck"]}
                  />
                </button>
              </div>
            </div>

            {/* Central Box Image Composition */}
            <div className={styles["hero-center-box-container"]}>
              <img
                src={cajaTransparente}
                alt="Caja Elpaket Premium"
                className={styles["hero-box-image"]}
                loading="eager"
                decoding="async"
              />
            </div>
          </div>

          {/* Right Column: Pickup Form Card */}
          <div
            className={styles["hero-right-column"]}
            id="pickup-form-container"
          >
            <div className={styles["hero-form-card-wrapper"]}>
              <PickupForm />
            </div>
          </div>
        </div>

        {/* Trust Banner Bar */}
        <div className={styles["hero-trust-banner"]}>
          <div className={styles["trust-item"]}>
            <FontAwesomeIcon
              icon={faShieldAlt}
              className={styles["trust-icon"]}
            />
            <span className={styles["trust-text"]}>
              Seguro y<br />
              protegido
            </span>
          </div>
          <div className={styles["trust-divider"]}></div>
          <div className={styles["trust-item"]}>
            <FontAwesomeIcon icon={faClock} className={styles["trust-icon"]} />
            <span className={styles["trust-text"]}>
              Entrega
              <br />
              5-7 días
            </span>
          </div>
          <div className={styles["trust-divider"]}></div>
          <div className={styles["trust-item"]}>
            <FontAwesomeIcon
              icon={faHeadset}
              className={styles["trust-icon"]}
            />
            <span className={styles["trust-text"]}>
              Soporte
              <br />
              siempre disponible
            </span>
          </div>
          <div className={styles["trust-divider"]}></div>
          <div className={styles["trust-item"]}>
            <div className={styles["trust-avatars-group"]}>
              <img
                src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=64&q=80"
                alt="Cliente 1"
                className={styles["trust-avatar"]}
              />
              <img
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=64&q=80"
                alt="Cliente 2"
                className={styles["trust-avatar"]}
              />
              <img
                src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=64&q=80"
                alt="Cliente 3"
                className={styles["trust-avatar"]}
              />
              <div className={styles["trust-avatar-badge"]}>+5K</div>
            </div>
            <span className={styles["trust-text"]}>Clientes satisfechos</span>
          </div>
        </div>
      </div>

      <PickupFormModal
        show={showPickupModal}
        onHide={() => setShowPickupModal(false)}
      />
    </section>
  );
};

export default HeroPickupSection;
